import { RecipientType, TriggerRecipient } from 'models/automation/Triggers';

/**
 * Some recipients might contain the `recipientUid` as null, thus needing the type to confirm which recipient it is.
 */
export const getRecipientOptionValue = (
  recipient: Pick<TriggerRecipient, 'recipientUid' | 'type'>,
) => {
  return [recipient.recipientUid, recipient.type].join(';');
};

/**
 * Extracts the recipient `recipientUid` and `type` from the string returned by `getRecipientOptionValue`.
 */
export const getRecipientUidAndTypeFromValue = (value: string) => {
  const [recipientUid, type] = value.split(';');

  return {
    recipientUid: recipientUid.length ? recipientUid : null,
    type: type as RecipientType,
  } satisfies Pick<TriggerRecipient, 'recipientUid' | 'type'>;
};
